import { supabase } from '../supabase-client.js'

class PlaylistManager {
    static #instance = null;
    #currentPlaylistId = null;
    
    static init() {
        if (!this.#instance) {
            this.#instance = new PlaylistManager();
        }
        return this.#instance;
    }

    async loadPlaylist(playlistId) {
        try {
            console.log('Loading playlist:', playlistId)
            // Load playlist data
            const { data: playlist, error: playlistError } = await supabase
                .from('playlists')
                .select('*')
                .eq('id', playlistId)
                .single()

            if (playlistError) {
                console.error('Playlist error:', playlistError)
                throw playlistError
            }
            if (!playlist) {
                console.error('Playlist not found')
                throw new Error('Playlist not found')
            }

            console.log('Playlist loaded:', playlist)
            this.#currentPlaylistId = playlistId

            return playlist
        } catch (error) {
            console.error('Error loading playlist:', error)
            throw error
        }
    }

    getCurrentPlaylistId() {
        return this.#currentPlaylistId
    }
}

export const playlistManager = PlaylistManager.init() 